var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadPdfBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_299_46",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_299_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95999 17.9742L4.21478 17.2082L6.63145 14.7915H4.61853V13.7082H8.45999V17.5494H7.37666V15.5575L4.95999 17.9742ZM10.1202 17.5832V16.4998H14.2435C14.3184 16.4998 14.3799 16.4758 14.4279 16.4278C14.476 16.3797 14.5 16.3182 14.5 16.2434V6.58317H11.4167V3.49984H5.75645C5.68159 3.49984 5.62013 3.52387 5.57207 3.57192C5.52402 3.61998 5.49999 3.68143 5.49999 3.7563V12.048H4.41666V3.7563C4.41666 3.38657 4.54749 3.07081 4.80916 2.809C5.07096 2.54734 5.38673 2.4165 5.75645 2.4165H12.2083L15.5833 5.7915V16.2434C15.5833 16.6131 15.4525 16.9289 15.1908 17.1907C14.929 17.4523 14.6133 17.5832 14.2435 17.5832H10.1202Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPdfBtnIcon);
export default __webpack_public_path__ + "static/media/upload-pdf-btn-icon.3f3c45cf115fe3b9b174f8ccaa79951c.svg";
export { ForwardRef as ReactComponent };